import CustomCard from '@/components/customCard';
import RegularText from '@/components/RegularText';
import ruleSlice, { IRuleErrorField, ruleErrorsSelector, ruleSettingsSelector } from '@/redux/slice/rule.slice';
import { IRule } from '@/types/newSetup.type';
import { TextField } from '@shopify/polaris';
import { DeleteIcon } from '@shopify/polaris-icons';
import { useDispatch, useSelector } from 'react-redux';

interface IProps {
  onDismiss?: () => void;
}

export default function CardTooltip(props: IProps) {
  const dispatch = useDispatch();
  const ruleSettings = useSelector(ruleSettingsSelector);
  const errors = useSelector(ruleErrorsSelector);
  const handleUpdateValue = (key: keyof IRule, value: IRule[keyof IRule]) => {
    dispatch(ruleSlice.actions.handleChange({ key, value }));
  };

  const handleErrors = (field: IRuleErrorField, msg: string) => {
    dispatch(ruleSlice.actions.handleSetError({ value: { field, msg } }));
  };
  return (
    <CustomCard
      textClassName={'bold-text-styled'}
      title={'Tooltip'}
      secondaryActions={
        props.onDismiss
          ? {
              onAction: props.onDismiss,
              buttonProps: {
                icon: DeleteIcon,
                tone: 'critical',
              },
            }
          : undefined
      }
    >
      <RegularText>Show additional information</RegularText>
      <div className="d-flex flex-column gap-12 mt-8 wrap-text-field">
        <TextField
          autoComplete="off"
          label={'Text'}
          requiredIndicator
          value={ruleSettings.privacyPageText}
          onChange={(value) => {
            handleUpdateValue('privacyPageText', value);
            handleErrors('tooltipText', value ? '' : 'This field is required');
          }}
          error={errors?.find((item) => item.field === 'tooltipText')?.msg}
          onBlur={() => handleErrors('tooltipText', ruleSettings.privacyPageText ? '' : 'This field is required')}
        />
        <TextField
          autoComplete="off"
          label={'URL'}
          value={ruleSettings.privacyPageUrl}
          onChange={(value) => handleUpdateValue('privacyPageUrl', value)}
        />
        <TextField
          autoComplete="off"
          label={'More info text'}
          value={ruleSettings.privacyMore}
          onChange={(value) => handleUpdateValue('privacyMore', value)}
        />
      </div>
    </CustomCard>
  );
}
